import * as React from 'react'
import { hideMessage, showInfoMessage } from 'uiComponents/message'
import './styles.scss'

const TOAST_ID = 'pos-terminals-info'

function PosTerminals() {
    React.useEffect(() => {
        showInfoMessage(
            'Soon, this is where you\'ll manage your Convious POS and Kiosk terminals — built with operators, not just for them. Stay tuned.',
            TOAST_ID,
            { duration: Infinity },
        )
        return () => {
            hideMessage(TOAST_ID)
        }
    }, [])

    return (
        <div className="pos-iframe-wrapper">
            <iframe src="https://convious.com/pos" title="Point of Sale" />
        </div>
    )
}

export default PosTerminals
